/**
 * PAPPO — ForwardModal
 * Seletor de conversa de destino ao encaminhar uma mensagem.
 */

import { X } from 'lucide-react';
import type { Conversation } from '../../types/message';
import { Avatar } from '../common/Avatar';
import styles from './ForwardModal.module.css';

interface ForwardModalProps {
  conversations: Conversation[];
  /** Conversa atual (excluída da lista de destinos) */
  currentConversationId?: number;
  onPick: (conversationId: number) => void;
  onClose: () => void;
}

function convName(c: Conversation): string {
  if (c.is_group) return c.name || 'Família';
  return c.other_user?.alias || c.other_user?.display_name || 'Conversa';
}

function convAvatar(c: Conversation): string | null | undefined {
  return c.is_group ? c.avatar_url : c.other_user?.avatar_url;
}

export function ForwardModal({
  conversations,
  currentConversationId,
  onPick,
  onClose,
}: ForwardModalProps) {
  const targets = conversations.filter((c) => c.id !== currentConversationId);

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={styles.card}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label="Encaminhar para"
      >
        <div className={styles.head}>
          <span className={styles.title}>Encaminhar para…</span>
          <button className={styles.closeBtn} onClick={onClose} aria-label="Fechar">
            <X size={18} />
          </button>
        </div>
        {targets.length === 0 ? (
          <p className={styles.empty}>Nenhuma outra conversa disponível.</p>
        ) : (
          <ul className={styles.list}>
            {targets.map((c) => (
              <li key={c.id}>
                <button className={styles.item} onClick={() => onPick(c.id)}>
                  <Avatar name={convName(c)} src={convAvatar(c)} size="sm" />
                  <span className={styles.itemName}>{convName(c)}</span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
